import { render, staticRenderFns } from "./Searchbox.vue?vue&type=template&id=906fd87a&scoped=true"
import script from "./Searchbox.vue?vue&type=script&lang=js"
export * from "./Searchbox.vue?vue&type=script&lang=js"
import style0 from "./Searchbox.vue?vue&type=style&index=0&id=906fd87a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906fd87a",
  null
  
)

export default component.exports